module.exports = __webpack_public_path__ + "static/media/tape.efa12f3c.svg";